/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
const hasTelemetryPropFunctions = (x) => typeof (x === null || x === void 0 ? void 0 : x.getTelemetryProperties) === "function" &&
    typeof (x === null || x === void 0 ? void 0 : x.addTelemetryProperties) === "function";
export const hasErrorInstanceId = (x) => typeof (x === null || x === void 0 ? void 0 : x.errorInstanceId) === "string";
/** type guard for IFluidErrorBase interface */
export function isFluidError(e) {
    return typeof (e === null || e === void 0 ? void 0 : e.errorType) === "string" &&
        typeof (e === null || e === void 0 ? void 0 : e.message) === "string" &&
        hasErrorInstanceId(e) &&
        hasTelemetryPropFunctions(e);
}
/** type guard for old standard of valid/known errors */
export function isValidLegacyError(e) {
    return typeof (e === null || e === void 0 ? void 0 : e.errorType) === "string" &&
        typeof (e === null || e === void 0 ? void 0 : e.message) === "string" &&
        hasTelemetryPropFunctions(e);
}
//# sourceMappingURL=fluidErrorBase.js.map